import { IFiltersProps } from "@comparaonline/ui-filter-list";
import { IEntityFilterItem, IFilterItem, RenderFilterItem } from "../types";

const buildFilterItem = (entityFilter: IEntityFilterItem, renderFilterItem: RenderFilterItem) => (
  filter: IFilterItem
) => {
  const { id, label, slug, description } = filter;
  return {
    description: description || undefined,
    key: `${slug}-${id}`,
    renderComponent: renderFilterItem(entityFilter, filter),
    title: label
  };
};

const buildFilterGroup = (renderFilterItem: RenderFilterItem) => (
  entityFilter: IEntityFilterItem
) => {
  const { id, entity, filters, description } = entityFilter;
  const getFilterItem = buildFilterItem(entityFilter, renderFilterItem);
  return {
    description: description || undefined,
    items: filters.map(getFilterItem),
    key: id,
    title: entity.label
  };
};

export const getFilterGroups = (
  entityFilters: IEntityFilterItem[],
  renderFilterItem: RenderFilterItem
): IFiltersProps["filterGroups"] => {
  const getFilterGroup = buildFilterGroup(renderFilterItem);
  return entityFilters.map(getFilterGroup).filter(group => group.items.length > 0);
};
